import { apiHelper } from '@/util'
import { SHARED } from '@/constants/constants'

/* SERVICE EXPORT FUNCTION NAME */
export const inboxService = {
  getInboxMsg,
  getInboxMsgContent,
  readInboxMsg,
  deleteInboxMsg,
  readBulkInboxMsg,
  getUnreadInboxMsg,
  getExclusiveBonusFt,
  readExclusiveBonusFt,
}

/* SERVICE URL PATH */
const INBOX = {
  INBOX: 'inbox',
  CONTENT: 'content',
  READ: 'read/message',
  BULK: 'bulk/message',
  MESSAGE: 'get/messagev2',
  MESSAGE_DETAIL: 'get/message',
  REMOVE: 'remove/message',
  REMOVES: 'remove/messages',
  UNREAD_MESSAGE: 'get/unread/message',
  EXCLUSIVE_BONUS_FT: 'exclusive-bonus-ft',
  READ_EXCLUSIVE_BONUS_FT: 'read/exclusive-bonus-ft'
}

function getInboxMsg() {
  return apiHelper().get(`${INBOX.INBOX}/${INBOX.MESSAGE}`)
}

async function getInboxMsgContent(obj) {
  return apiHelper().get(`/${INBOX.INBOX}/${INBOX.MESSAGE_DETAIL}/${INBOX.CONTENT}/${obj.msgId}/${obj.category}`)
}

function readInboxMsg(obj) {
  return apiHelper().post(`/${INBOX.INBOX}/${INBOX.READ}/${obj.msgId}/${obj.categoryId}`)
}

function deleteInboxMsg(payload) {
  return apiHelper().post(`/${INBOX.INBOX}/${INBOX.REMOVES}`, payload)
}

function readBulkInboxMsg(obj) {
  return apiHelper().post(`/${INBOX.INBOX}/${INBOX.BULK}/${obj.msgId}`)
}

function getUnreadInboxMsg() {
  return apiHelper().get(`/${INBOX.INBOX}/${INBOX.UNREAD_MESSAGE}`)
}

function getExclusiveBonusFt() {
  return apiHelper().get(`${INBOX.INBOX}/${INBOX.EXCLUSIVE_BONUS_FT}`)
}

function readExclusiveBonusFt(obj) {
  return apiHelper().post(`/${INBOX.INBOX}/${INBOX.READ_EXCLUSIVE_BONUS_FT}/${obj.msgId}`)
}